var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === 'dashboard')?_c('div',[_c('div',{staticClass:"gcse-searchbox-only",attrs:{"data-resultsUrl":"/search"}})]):_c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"gcse-search"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }